import React from "react";
import styled, { css } from "styled-components";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";
import { Button } from "src/library/components/Button";
import { Input } from "src/library/components/Forms";
import useCache from "src/core/shared/hooks/useCache";

import { useDashboardApi } from "../../api/dashboard.api";
import { useDashboardContext } from "../../contexts/DashboardContext";
import { GET_DAHSBOARDS_CACHE_KEY } from "./DashboardSwitcher";

type CreateDashboardModalProps = Pick<BasicModalProps, "onDismiss" | "open">;

export const CreateDashboardModal: React.ReactFCWithChildren<CreateDashboardModalProps> = ({ onDismiss, open }) => {
  const [ createDashboardResponse, createDashboardRequest ] = useDashboardApi("CREATE_DASHBOARD");
  const { updateCurrentDashboard } = useDashboardContext();
  const { removeItemByKey } = useCache();

  const {
    handleSubmit, register, getValues, errors
  } = useForm<{name: string}>();

  const createDashboard = React.useCallback(() => {
    const formValues = getValues();

    createDashboardRequest(formValues);
  }, [ createDashboardRequest, getValues ]);

  React.useEffect(() => {
    if (createDashboardResponse.data) {
      toast.success("Dashboard created");
      onDismiss();
      removeItemByKey(GET_DAHSBOARDS_CACHE_KEY);
      updateCurrentDashboard(createDashboardResponse.data);
    } else if (createDashboardResponse.error) {
      toast.error(createDashboardResponse.error.message);
    }
  }, [ createDashboardResponse.data, createDashboardResponse.error ]);

  return (
    <StyledBasicModal
      title="Create New Dashboard"
      open={open}
      onDismiss={() => onDismiss()}
    >
      <form onSubmit={handleSubmit(createDashboard)}>
        <Input
          label="Dashboard Name"
          as="input"
          name="name"
          ref={register({ required: "Please provide a name" })}
          error={errors.name?.message}
        />

        <Button
          className="submit-button"
          loading={createDashboardResponse.pending}
          type="submit"
        >
          Create dashboard
        </Button>
      </form>

    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  ${({ theme }) => css`
    .submit-button {
      margin-top: ${theme.spacing.margins.md};
    }
  `}
`;
